import Box from '@totallymoney/ui/components/Box'

const CardPageContentBase = ({ children }: { children: React.ReactNode }) => (
    <Box
        as="ul"
        display="grid"
        flexDirection="column"
        gridGap="space10"
        width="100%"
    >
        {children}
    </Box>
)

export default CardPageContentBase
